import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5206118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-info" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row input-row" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "givenNameInput",
  class: "form-label"
}, "Given name", -1))
const _hoisted_6 = ["readonly"]
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "familyNameInput",
  class: "form-label"
}, "Surname", -1))
const _hoisted_9 = ["readonly"]
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "row input-row" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "genderSelect",
  class: "form-label"
}, "Gender", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Male" }, "Male", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "Female" }, "Female", -1))
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "row input-row" }
const _hoisted_20 = { class: "col-8" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "emailInput",
  class: "form-label"
}, "Contact email", -1))
const _hoisted_22 = ["readonly"]
const _hoisted_23 = { class: "col-4" }
const _hoisted_24 = { class: "row input-row" }
const _hoisted_25 = { class: "col-8" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "altEmailInput",
  class: "form-label"
}, "Alternate email", -1))
const _hoisted_27 = ["readonly"]
const _hoisted_28 = { class: "col-4" }
const _hoisted_29 = { class: "row input-row" }
const _hoisted_30 = { class: "col-8" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "mobileNumberInput",
  class: "form-label"
}, "Mobile number", -1))
const _hoisted_32 = ["readonly"]
const _hoisted_33 = { class: "col-4" }

import { reactive, computed, watch } from "vue"
import { useUserStore } from '@/gp/UserStore'
import { User } from '@/gp/GroupAdminModel'
import { PatchChange, PatchChangeValue } from '@/util/Api'
import { useTokenManager } from "@/auth/TokenManager"
import PrivacyLevelSelect from '@/account/PrivacyLevelSelect.vue'
import { propertyChanged } from "@/util/EditMode"


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInfo',
  props: {
    userId: {},
    disabled: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



__expose({
  hasChanges,
  canSave,
  saveAsync
})

const userStore = useUserStore()
const tokenManager = useTokenManager()

const userIdRef = computed(() => props.userId ?? tokenManager.current.userId!)
const userRef = computed(() => userStore.getAsyncUser(userIdRef.value)?.data)
const editUser = reactive(new User())
const editProperties = [
  'givenName',
  'surname', 
  'namePrivacy',
  'gender',
  'email',
  'emailPrivacy',
  'email2',
  'email2Privacy',
  'mobileNumber',
  'mobileNumberPrivacy',
] as (keyof User)[]

watch(() => props.userId, () => {
  if (userRef.value) {
    Object.assign(editUser, userRef.value)
  }
}, { immediate: true })

function hasChanges() {
  return userRef.value && editProperties.some(key => propertyChanged(editUser[key], userRef.value![key]))
}

function canSave() {
  return hasChanges() && (!!editUser.givenName || !!editUser.surname)
}

async function saveAsync() {
  if (!userRef.value)
    return
  
  const changes: PatchChange[] = []
  for (const key of editProperties) {
    if (editUser[key] != userRef.value[key]) {
      changes.push(new PatchChange(`/${key}`, editUser[key] as PatchChangeValue))
    }
  }

  if (changes.length) {
    await userStore.patchAsync(userIdRef.value!, changes)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (userRef.value)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "givenNameInput",
                readonly: _ctx.disabled,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editUser.givenName) = $event))
              }, null, 8, _hoisted_6), [
                [_vModelText, editUser.givenName]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "familyNameInput",
                readonly: _ctx.disabled,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editUser.surname) = $event))
              }, null, 8, _hoisted_9), [
                [_vModelText, editUser.surname]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(PrivacyLevelSelect, {
                id: "namePrivacySelect",
                disabled: _ctx.disabled,
                modelValue: editUser.namePrivacy,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editUser.namePrivacy) = $event))
              }, null, 8, ["disabled", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                id: "genderSelect",
                disabled: _ctx.disabled,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editUser.gender) = $event))
              }, _hoisted_18, 8, _hoisted_14), [
                [_vModelSelect, editUser.gender]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "emailInput",
                readonly: _ctx.disabled,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((editUser.email) = $event))
              }, null, 8, _hoisted_22), [
                [_vModelText, editUser.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(PrivacyLevelSelect, {
                id: "emailPrivacySelect",
                disabled: _ctx.disabled,
                modelValue: editUser.emailPrivacy,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((editUser.emailPrivacy) = $event))
              }, null, 8, ["disabled", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "altEmailInput",
                readonly: _ctx.disabled,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editUser.email2) = $event))
              }, null, 8, _hoisted_27), [
                [_vModelText, editUser.email2]
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(PrivacyLevelSelect, {
                id: "email2PrivacySelect",
                disabled: _ctx.disabled,
                modelValue: editUser.email2Privacy,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editUser.email2Privacy) = $event))
              }, null, 8, ["disabled", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "mobileNumberInput",
                readonly: _ctx.disabled,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editUser.mobileNumber) = $event))
              }, null, 8, _hoisted_32), [
                [_vModelText, editUser.mobileNumber]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(PrivacyLevelSelect, {
                id: "mobileNumberPrivacySelect",
                disabled: _ctx.disabled,
                modelValue: editUser.mobileNumberPrivacy,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editUser.mobileNumberPrivacy) = $event))
              }, null, 8, ["disabled", "modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})